var _rect, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFallingSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 480 480",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 480
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    width: 45,
    height: 478
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    width: 45,
    height: 475
  })), /*#__PURE__*/React.createElement("rect", {
    x: 135,
    width: 45,
    height: 470,
    opacity: 0.98,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    width: 45,
    height: 460,
    opacity: 0.95,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225,
    width: 45,
    height: 410,
    opacity: 0.85,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 270,
    width: 45,
    height: 220,
    opacity: 0.5,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315,
    width: 45,
    height: 100,
    opacity: 0.3,
    style: {
      isolation: "isolate"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFallingSquare);
export default __webpack_public_path__ + "static/media/FallingSquare.ee5e89d99ffefb64c6fb8c38dd0f88ef.svg";
export { ForwardRef as ReactComponent };